function getRootKey() {
  return this.rootKey;
}

module.exports = getRootKey;
